const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

import { getSettings } from "./settings";

// transcribe : POST l'audio vers /api/transcribe (Whisper côté serveur).
export async function transcribe(audioBlob) {
  const type = audioBlob.type || "audio/webm";
  let ext = "webm";
  if (type.includes("mp4")) ext = "mp4";
  else if (type.includes("mpeg") || type.includes("mp3")) ext = "mp3";
  else if (type.includes("wav")) ext = "wav";
  else if (type.includes("ogg")) ext = "ogg";

  const form = new FormData();
  form.append("file", audioBlob, `recording.${ext}`);
  // Langue de saisie choisie dans les Réglages (améliore la précision).
  const lang = getSettings().inputLang;
  if (lang) form.append("language", lang);

  const res = await fetch(`${API}/transcribe`, {
    method: "POST",
    body: form,
  });
  if (!res.ok) {
    const detail = await res.text().catch(() => "");
    throw new Error(`Transcription échouée: ${detail}`);
  }
  const data = await res.json();
  return data.text || "";
}
